<!--
 * @LastEditors Please set LastEditors
 * @Date 2023-08-18 15:08
 * @LastEditTime 2023-12-05 19:12
 * @FilePath /locationpms-pc/src/common/components/Bussiness/IM/IMMessageIcon.vue
 * @Description 悬浮消息
-->

<template>
  <div v-if="unreadMsgNum && !hideMessageRoute.includes($route.name)" class="im-wrapper" :style="{ 'z-index': zIndex }">
    <div class="header pointer" @click="handleClick">
      <ElBadge :value="unreadMsgNum" :max="99" class="title-icon" :hidden="!unreadMsgNum">
        <IconSvg :style="{'border-radius':'50%',overflow:'hidden'}" name="iconic_new" class="fn-30"/>
      </ElBadge>
      <span class="title-text">商机消息</span>
    </div>
  </div>
</template>

<script>
import IMUnreadMsgNumMixin from 'src/common/components/Bussiness/IM/IMUnreadMsgNumMixin.js';
import IconSvg from 'src/common/components/Iconfont/IconSvg.vue';
import eventLib from '@/common/utils/document-event';

export default {
  name: 'IMMessageIcon',
  components: {
    IconSvg,
  },
  mixins: [IMUnreadMsgNumMixin],
  props: {
    // 悬浮层级
    zIndex: {
      type: Number,
      default: 100
    }
  },

  data() {
    return {
      hideMessageRoute: ['MicroResourceBrandBusiness', 'MicroResourceBusiness']
    };
  },

  methods: {
    handleClick() {
      // this.$router.push('/lhb-micro-pms/brandBusiness');
      eventLib.dispatch('OPEN_IM');
    },
  },
};
</script>

<style lang="scss" type="text/scss" scoped>
.im-wrapper {
  position: fixed;
  right: 0;
  bottom: 110px;
  background: #FFFFFF;
  box-shadow: 0px 0px 8px 0px rgba(204,204,204,0.4);
  .header {
    padding: 14px 14px;
    border-radius: 4px 0px 0px 4px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .title {
      /deep/ .el-badge__content {
        background: #F23030;
        border: none;
      }
      &-text {
        margin-top: 6px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
      }
    }

  }
}
</style>
